


<ng-container >
  @if (locations.length > 0) {
    <div class="form-group form-group--sm mt-30 ml-15 ml-md-0">
      <label class="font-semibold">{{locations[0].class_name}}</label>
    </div>
  }

  <div class="discount-panel">
    @for (location of locations; track location) {
      @if (collation?.class_id === item?.class_id) {
        <div class="discount-panel__item">
          <div class="discount-panel__heading">
            <div class="discount-panel__heading-name">
              <strong>{{location.location_name}}</strong>
              <p>{{location.location_address}}</p>
            </div>
          </div>
          <div class="discount-panel__tray">
            <div class="discount-panel__actions">
              <button (click)="editItem(collation)" class="text-link" data-toggle="modal" data-target="#edit-modal">Edit</button>
              <span>|</span>
              <button (click)="questionService?.setSelectedItem(collation)" class="action-remove text-link">Remove</button>
            </div>
          </div>
          <div class="discount-panel__offers" style="display: none;">
            <a href="javascript:void(0);">
              <div class="discount-panel__offers-icon">
                <svg class="icon"><use xlink:href="#tag"></use></svg>
              </div>
              <div class="discount-panel__offers-name">
                <strong>Get 15% off</strong> by insuring another vehicle!
              </div>
              <div class="discount-panel__offers-caret">
                <svg class="icon"><use xlink:href="#chevron-right-small"></use></svg>
              </div>
            </a>
            <a href="javascript:void(0);">
              <div class="discount-panel__offers-icon">
                <svg class="icon"><use xlink:href="#lowest-price"></use></svg>
              </div>
              <div class="discount-panel__offers-name">
                Let's try to <strong>lower your premium.</strong>
              </div>
              <div class="discount-panel__offers-caret">
                <svg class="icon"><use xlink:href="#chevron-right-small"></use></svg>
              </div>
            </a>
          </div>
        </div>
      }
    }
  </div>
</ng-container>
@if (checkAddAnother()) {
  <div class="question-panel question-panel--mini">
    <a href="javascript:void(0);" (click)="gotToNext()" class="question-panel__add">
      <div class="button-control">
        <svg class="icon"><use xlink:href="#plus-filled"></use></svg><strong>Add Another Item</strong>
      </div>
    </a>
  </div>
}

<div class="modal fade modal--alert" id="remove-modal-summary" tabindex="-1" role="dialog"
  aria-labelledby="restart-modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/{{sessionDetails?.category_id}}/avatar/unsure.png" class="img-fluid" alt="">
          </div>
          <a href="javascript:void(0);" class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </a>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h3>Are you sure?</h3>
            <p>You are about to remove {{selectedItem?.description_1.split('|')[2]}}</p>
          </div>
        </div>
      </div>

      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:;" (click)="questionService?.removeItem()" class="button button--lg button--secondary" data-toggle="modal" data-dismiss="modal">Yes, please do it</a>
          <a href="javascript:;" class="button button--lg button--primary" data-toggle="modal" data-dismiss="modal">No, please don't</a>
        </div>
      </div>
    </div>
  </div>
</div>

<!--<div class="discount-more">
<div class="discount-more__icon">
  <img id="media" src="assets/icn/discount.svg" class="icon"/>
</div>
<div class="discount-more__content">
  <h5 id="header">Stand to get 15% off</h5>
  <p id="body">You could earn a discount by insuring more than one vehicle with the same primary driver!</p>
</div>
</div>-->
<!-- ./discount-more -->
